import { render } from "./lista_ventas.vue?vue&type=template&id=578caf4e"
import script from "./lista_ventas.vue?vue&type=script&lang=js"
export * from "./lista_ventas.vue?vue&type=script&lang=js"

import "./lista_ventas.vue?vue&type=style&index=0&id=578caf4e&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__